import {
	APP_CONFIG_GET,
	APP_CONFIG_ERROR
} from '../types';

let initialState = {
	app_config: null,
	app_config_error: null
};

export default function appsReducer (state = initialState, action) {
	switch (action.type) {
		case APP_CONFIG_GET:
			return {
				...state,
				app_config: action.payload,
				app_config_error: null
			};
		case APP_CONFIG_ERROR:
			return {
				...state,
				app_config_error: action.payload
			};
		default:
			return state;
	}
}
